module.exports = __webpack_public_path__ + "static/image/videoInfo-related.svg?306c4e287394a9580a2aa5ea84a9b163";